<template lang="pug">
.mprn-form
    TermsAgreement(:show-ber-agreement="true")
    UserMPRN(v-if="termsAccepted && !fileUploaded")
    UploadMPRN(v-if="termsAccepted && mprnValid && !fileUploaded")
    SuccessMPRN(v-if="fileUploaded")
    AddressSearch(v-if="addressRequired && fileUploaded")
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import TermsAgreement from '@/components/forms/questions/TermsAgreement.vue';
import UserMPRN from '@/components/forms/questions/mprn/UserMPRN.vue';
import UploadMPRN from '@/components/forms/questions/mprn/UploadMPRN.vue';
import SuccessMPRN from '@/components/forms/questions/mprn/SuccessMPRN.vue';
import AddressSearch from "./questions/AddressSearch.vue";
import { storeToRefs } from 'pinia';
import { useSelections, useSettings } from "@/store";
import { computed } from "vue";

export default defineComponent({
    name: "MPRNForm",
    components: {
        TermsAgreement,
        UserMPRN,
        UploadMPRN,
        SuccessMPRN,
        AddressSearch,
    },
    setup() {
        const { termsAccepted, mprnValid, fileUploaded, addressResult } = storeToRefs(useSelections());        
        const { settings } = storeToRefs(useSettings());
        const addressRequired = computed(() => !!settings.value?.autoaddressKey);
        return {
            termsAccepted,
            mprnValid,
            fileUploaded,
            settings,
            addressResult,
            addressRequired
        }
    },
})

</script>
